export const LINK_ATTRS = { target: '_blank', rel: 'noreferrer' };
export const YOULEND_WEBSITE = 'https://youlend.com';
export const MIN_REQUIRED_MONTHLY_PAYMENTS_AMOUNT = 2500;

export const MewsPaymentsLinksMap: Record<string, string> = {
    en: 'https://www.mews.com/en/products/payments',
    nl: 'https://www.mews.com/nl/producten/payments',
    de: 'https://www.mews.com/de/produkte/payments',
    fr: 'https://www.mews.com/fr/produits/payments',
    es: 'https://www.mews.com/es/productos/payments',
};

export const YoulendFormLinksMap: Record<string, string> = {
    GB: 'https://youlend.com/apply/mews/signup',
    NL: 'https://youlend.com/apply/mews/nl/signup',
    DE: 'https://youlend.com/apply/mews/de/signup',
    BE: 'https://youlend.com/apply/mews/be-fr/signup',
    ES: 'https://youlend.com/apply/mews/es/signup',
    US: 'https://youlend.us/apply/mews/en-us/signup',
    IE: 'https://youlend.com/apply/mews/en-ie/signup',
    PL: 'https://youlend.com/apply/mews/pl/signup',
};
